import React, { useState, ReactNode, HTMLAttributes } from "react";
import Typography from "@mui/material/Typography";
import ToolTipComponent from "../tooltip";

interface TextProps extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  children?: ReactNode;
  className?: string;
  tooltipContent?: ReactNode;
  alwaysShowTooltip?: boolean;
  sx?: any;
  placement?: any;
}

const Text: React.FC<TextProps> = ({
  children,
  className,
  tooltipContent,
  alwaysShowTooltip = false,
  style,
  sx = {},
  placement,
}) => {
  const [tooltipTitle, setTooltipTitle] = useState<any>("");

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    const el = event.currentTarget;
    const hasOverflow = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

    if (alwaysShowTooltip || (hasOverflow && sx.whiteSpace != "normal")) {
      setTooltipTitle(tooltipContent || children || "");
    }
  };

  const handleMouseLeave = () => {
    setTooltipTitle("");
  };

  return (
    <ToolTipComponent content={tooltipTitle} position={placement ?? "top"}>
      <Typography
        component="span"
        className={className}
        style={style}
        sx={{
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          verticalAlign: "bottom",
          ...sx,
        }}
        variant="inherit"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Typography>
    </ToolTipComponent>
  );
};

export default Text;
